import React from "react";
import { Button } from "@material-ui/core";
import GridItem from "components/Grid/GridItem";

const DocumentPreview = ({
  file,
  index,
  isPdf,
  setImageUrl,
  classes,
  setViewImageModal
}) => {
  const openImage = (url) => {
    setImageUrl(url);
    setViewImageModal(true);
  };
  return (
    <GridItem xs={12} sm={12} md={12} lg={12}>
      {isPdf ? (
        <a
          href={file}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "block",
            width: "100%",
            maxWidth: "150px",
            padding: "20px",
            border: "1px solid #ccc",
            textAlign: "center",
            borderRadius: "8px",
            textDecoration: "none",
          }}
        >
          📄 View PDF
        </a>
      ) : (
        <>
          <img
            src={file}
            alt={`document-${index}`}
            style={{
              width: "100%",
              maxWidth: "150px",
              height: "auto",
              borderRadius: "8px",
            }}
          />

          <Button
            variant="contained"
            className={classes.nextButton}
            onClick={() => openImage(file)}
            style={{ margin: "0 15%" }}
          >
            View
          </Button>
        </>
      )}
    </GridItem>
  );
};

export default DocumentPreview;